import { v4 as uuidv4 } from "uuid";

import { Deposit } from "../../../Deposits/DepositCard/deposit-dtos";

export const buildDepositSplit = (deposit: Deposit, usedQuantity: number, now: Date) => {
  const remainderUuid = uuidv4();
  const shared = {
    commodity: deposit.commodity?.id || deposit.farmer_produce?.commodity?.id,
    unit_of_measure: deposit.unit_of_measure.code,
    quality: deposit.quality,
    farmer_uuid: deposit.farmer.person.uuid,
    offer: undefined,
    mobile_creation_time: deposit.collection_time ?? deposit.backend_creation_time,
    mobile_last_change_time: now.toISOString(),
    original_quantity: deposit.original_quantity ?? deposit.quantity,
    price: deposit.price,
    picture_urls: deposit.picture_urls,
    paid_to_farmer_on_deposit: false,
    aggregator_administrator: deposit.aggregator_administrator,
  };

  return {
    remainder: {
      ...shared,
      uuid: remainderUuid,
      original_deposit_uuid: undefined,
      quantity: (Number(deposit.quantity) - usedQuantity).toFixed(5),
    },
    used: {
      ...shared,
      uuid: deposit.uuid,
      original_deposit_uuid: remainderUuid,
      quantity: usedQuantity.toFixed(5),
    },
  };
};
